import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FiX, FiMenu } from 'react-icons/fi';
import { FaYoutube, FaInstagram, FaFacebookF, FaLinkedinIn,FaCalculator,FaPhoneAlt } from 'react-icons/fa';
import {DropdownButton,Dropdown} from 'react-bootstrap'
const SocialShare = [
	{ Social: <FaFacebookF />, link: 'https://www.facebook.com/' },
	{ Social: <FaInstagram />, link: 'https://www.instagram.com/' },
	{ Social: <FaYoutube />, link: 'https://youtube.com/' },
	{ Social: <FaLinkedinIn />, link: 'https://www.linkedin.com/' },
];
class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			changedColor: 'bg-color',
			textLink: '',
			visible: false,
			visible2: false,
			moveon: false,
			moveon2: false,
			active: false
		};
		this.myRef1 = React.createRef();
		this.myRef2 = React.createRef();
		this.myRef = React.createRef();
		this.menuTrigger = this.menuTrigger.bind(this);
		this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
		//  this.subMetuTrigger = this.subMetuTrigger.bind(this);
		window.addEventListener('load', function() {
			console.log('All assets are loaded');
		});
	}
	callUs =() => {
		window.location.href='tel:+16045952800'
	}
	toClientInfo =() => {
		window.location.href='/clientinformation'
	}
	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
		console.log(this.props.customHeaderText);
	}

	handleScroll = () => {
		if (window.pageYOffset > 660) {
			this.setState({ changedColor: 'bg-color' });
			this.setState({ textLink: 'black' });
		} else {
			this.setState({ changedColor: 'bg-color' });
			this.setState({ textLink: 'black' });
		}
	};

	menuTrigger() {
		document.querySelector('.header-wrapper').classList.toggle('menu-open');
	}

	CLoseMenuTrigger() {
		document.querySelector('.header-wrapper').classList.remove('menu-open');
	}
	toggleClass() {
		const currentState = this.state.active;
		this.setState({ active: !currentState });
	};
	render() {
		
		var elements = document.querySelectorAll('.has-droupdown > a');
		for (var i in elements) {
			if (elements.hasOwnProperty(i)) {
				elements[i].onclick = function() {
					if(this.parentElement.classList.contains('submenu')){

                        this.parentElement.querySelector('.submenu').classList.toggle('active');
                        this.classList.toggle('open');
                    }
				};
			}
		}
		// const { logo, color='default-color' } = this.props;
		// let logoUrl;
		// if(logo === 'light'){
		//     logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Digital Agency" />;
		// }else if(logo === 'dark'){
		//     logoUrl = <img src="/assets/images/logo/logo-dark.png" alt="Digital Agency" />;
		// }else if(logo === 'symbol-dark'){
		//     logoUrl = <img src="/assets/images/logo/logo-symbol-dark.png" alt="Digital Agency" />;
		// }else if(logo === 'symbol-light'){
		//     logoUrl = <img src="/assets/images/logo/logo-symbol-light.png" alt="Digital Agency" />;
		// }else{
		//     logoUrl = <img src="/assets/images/logo/logo.png" alt="Digital Agency" />;
		// }
		
		return (
			<header
				ref={r => (this.ref = r)}
				id='header'
				className={'header-area header-transparent ' + this.state.changedColor}
				// className={`header-area header--transparent ${color}`}
			>
				<div className='header-wrapper col-12' id='header-wrapper' style={{ paddingLeft: '0', paddingRight: '0' }}>
					<div className='header-left col-lg-2' style={{ padding: 0 }}>
						<div className='logo' style={{ paddingTop: '5%' }}>
							<a>
								<a href='/'>
									<img height='auto' width='200' src={require('../../../assets/images/service/MOONLM.png')} />
								</a>
							</a>
						</div>
					</div>
					<nav className='mainmenunav col-lg-5 col-md-5' style={{ paddingTop: '1.2%', paddingLeft: '0',paddingRight:0 }}>
						<ul className='mainmenu'>
							<li>
								<Link to='/about'>About</Link>
								{/* <ul className="submenu">
                                        <li><Link to="/main-demo">Main Demo</Link></li>
                                        <li><Link to="/dark-main-demo">Main Demo Dark</Link></li>
                                        <li><Link to="/creative-agency">Creative Agency</Link></li>
                                        <li><Link to="/creative-landing">Creative One Page</Link></li>
                                        <li><Link to="/creative-portfolio">Creative Portfolio</Link></li>
                                        <li><Link to="/personal-portfolio">Personal Portfolio</Link></li>
                                        <li><Link to="/portfolio-landing">Portfolio One Page</Link></li>
                                        <li><Link to="/dark-portfolio-landing">Portfolio One Page 02</Link></li>
                                        <li><Link to="/digital-agency">Digital Agency</Link></li>
                                        <li><Link to="/startup">Startup</Link></li>
                                        <li><Link to="/paralax">Paralax</Link></li>
                                        <li><Link to="/portfolio-home">Minimal Portfolio</Link></li>
                                        <li><Link to="/business">Business</Link></li>
                                        <li><Link to="/home-particles">Home Particles</Link></li>
                                        <li><Link to="/studio-agency">Studio Agency</Link></li>
                                        <li><Link to="/designer-portfolio">Designer Portfolio</Link></li>
                                    </ul> */}
                                </li>
                                <li className="has-droupdown"><a style={{cursor: 'pointer'}} onClick={ () => this.setState({active: !this.state.active}) }>Services</a>
                                    <ul className="submenu" className={this.state.active ? 'active' : 'null' && 'submenu'} >
                                        {/* <li><Link to="/residential">Residential</Link></li> */}
										<li><Link to="/localmoving">Local Moving</Link></li>
                                        <li><Link to="/longDistance">Long Distance Moving</Link></li>
                                        <li><Link to="/commercial">Commercial</Link></li>
										<li><Link to="/piano">Piano</Link></li>
										<li><Link to="/large-and-heavy">Large & Heavy Item Moving</Link></li>
                                        <li><Link to="/packing">Packing/Unpacking</Link></li>
                                        {/* <li><Link to="/movingtype">Moving/Unmoving</Link></li> */}
										
                                        
                                        <li><Link to="/storage">Storage</Link></li>
                                        
										<li><Link to="/furnituremoving">Furniture Moving</Link></li>
										{/* <li><Link to="/furnitureassembly">Furniture Assembly</Link></li> */}
                                    </ul>
                                </li>
                                {/* <li><Link to="/moving">Moving Supplies</Link></li> */}
                                <li><Link to="/blogdetails" >Blog</Link>
                                
                                    {/* <ul className="submenu">
                                        <li><Link to="/blog">Blog List</Link></li>
                                        <li><Link to="/blog-details">Blog Details</Link></li>
                                        <li><Link to="/service">Service</Link></li>
                                        <li><Link to="/service-details">Service Details</Link></li>
                                        <li><Link to="/portfolio">Portfolio</Link></li>
                                        <li><Link to="/portfolio-details">Portfolio Details</Link></li>
                                        <li><Link to="/404">404</Link></li>
                                    </ul> */}
							</li>
							<li>
								<Link to='/tips'>Tips</Link>
								{/* <ul className="submenu">
                                        <li><Link to="/portfolio">Portfolio</Link></li>
                                        <li><Link to="/team">Team</Link></li>
                                        <li><Link to="/service">Service</Link></li>
                                        <li><Link to="/video-popup">Video Popup</Link></li>
                                        <li><Link to="/progressbar">Progressbar</Link></li>
                                        <li><Link to="/gallery">Gallery</Link></li>
                                        <li><Link to="/counters">Counters</Link></li>
                                        <li><Link to="/blog">Blog List</Link></li>
                                        <li><Link to="/clint-logo">Clint Logo</Link></li>
                                        <li><Link to="/contact-form">Contact Form</Link></li>
                                        <li><Link to="/google-map">Google Map</Link></li>
                                        <li><Link to="/columns">Columns</Link></li>
                                        <li><Link to="/pricing-table">Pricing Table</Link></li>
                                    </ul> */}
							</li>
							{/* <li>
								<Link to='/track'>Track</Link>
							</li> */}
							<li>
								<Link to='/contact'>Contact</Link>
							</li>
						</ul>
					</nav>
					<div className='header-right col-lg-5 col-md-3 col-sm-2' style={{ paddingTop: '.8%', paddingRight: 0,  paddingLeft: '0' }}>
					
					
					<div className='col-lg-12' style={{padding:0}} >
						<div className='row freeQuote' style={{justifyContent:'space-around'}}>
							<div className='col-lg-4 calculatordiv' style={{paddingTop:'.7%'}}>
								<button id="CalculatorBtn" onClick={this.callUs}>
									<div className='row' style={{margin: '0', justifyContent:'space-around'}}>
										<div className='col-log-3' style={{display:'flex', alignItems:'center'}}>
											<FaPhoneAlt/>
										</div> 
										<div className='col-log-9'>
											<p style={{fontWeight: 900}}>604 595 2800</p>
										</div> 
									</div>
								</button>
							</div>
							<div className='col-lg-4 col-md-0 calculatordiv' style={{padding:'0',paddingTop:'.7%'}}>
								<button id="CalculatorBtn" onClick={this.toClientInfo} style={{padding:'0',widht:'120%'}}>
									<div className='row' style={{margin: '0', justifyContent:'space-around'}}>
										<div className='col-log-3' style={{display:'flex', alignItems:'center'}}>
											<FaCalculator/>
										</div> 
										<div className='col-log-9'>
											<p style={{    fontSize: '2.8vh'}}>Free Calculator</p>
										</div> 
									</div>
								</button>
							</div>
							{/* <div className='social-share-inner' style={{paddingTop:'10px'}}>
								<ul className='social-share social-style--2 color-black d-flex justify-content-start liststyle'>
									{SocialShare.map((val, i) => (
										<li key={i}>
											<a href={`${val.link}`}>{val.Social}</a>
										</li>
									))}
								</ul>
							</div> */}
							<div className='header-btn'>
								<a className='rn-btn' href='/clientinformation'>
									<span style={{fontSize:'2.8vh'}}>Free Quote</span>
								</a>
							</div>
							{/* Start Humberger Menu  */}
							<div className='humberger-menu d-block d-lg-none pl--20'>
								<span onClick={this.menuTrigger} className='menutrigger text-white'>
									<FiMenu />
								</span>
							</div>
							{/* End Humberger Menu  */}
							<div className='close-menu d-block d-lg-none'>
								<span onClick={this.CLoseMenuTrigger} className='closeTrigger'>
									<FiX />
								</span>
							</div>
						</div>
				
					
						</div>
					
					</div>
				</div>
			</header>
		);
	}
}
export default Header;
